var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVoucherRecipient(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_564_4152",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_564_4152)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 16.8074C3.58467 16.7561 3.23083 16.5698 2.9385 16.2487C2.64617 15.9275 2.5 15.5497 2.5 15.1152V7.36117C2.5 7.14967 2.558 6.94709 2.674 6.75342C2.79 6.55992 2.95383 6.40609 3.1655 6.29192L9.9365 2.91117C10.1942 2.78434 10.4653 2.71834 10.75 2.71317C11.0347 2.70801 11.3058 2.77401 11.5635 2.91117L18.1848 6.29192C18.3591 6.37276 18.5027 6.50551 18.6155 6.69017C18.7282 6.87467 18.8063 7.06759 18.85 7.26892H16.8193L10.8848 4.25917C10.8398 4.23367 10.7948 4.22251 10.75 4.22567C10.7052 4.22884 10.6603 4.24001 10.6155 4.25917L4 7.54192V16.8074ZM7.19225 20.4997C6.68725 20.4997 6.25975 20.3247 5.90975 19.9747C5.55975 19.6247 5.38475 19.1971 5.38475 18.6919V10.4612C5.38475 9.95617 5.55975 9.52867 5.90975 9.17867C6.25975 8.82867 6.68725 8.65367 7.19225 8.65367H19.6923C20.1974 8.65367 20.625 8.82867 20.975 9.17867C21.325 9.52867 21.5 9.95617 21.5 10.4612V18.6919C21.5 19.1971 21.325 19.6247 20.975 19.9747C20.625 20.3247 20.1974 20.4997 19.6923 20.4997H7.19225ZM12.6135 14.6149L6.8845 11.6919V18.6919C6.8845 18.7818 6.91342 18.8555 6.97125 18.9132C7.02892 18.9708 7.10258 18.9997 7.19225 18.9997H19.6923C19.7821 18.9997 19.8558 18.9708 19.9135 18.9132C19.9712 18.8555 20 18.7818 20 18.6919V11.6919L14.2712 14.6149C14.0134 14.7523 13.7371 14.8209 13.4423 14.8209C13.1474 14.8209 12.8712 14.7523 12.6135 14.6149ZM13.577 13.4362L19.8845 10.2112C19.8525 10.192 19.8221 10.1776 19.7932 10.1679C19.7644 10.1583 19.7308 10.1534 19.6923 10.1534H7.19225C7.16025 10.1534 7.12825 10.1583 7.09625 10.1679C7.06408 10.1776 7.032 10.192 7 10.2112L13.3077 13.4362C13.3526 13.4618 13.3974 13.4747 13.4423 13.4747C13.4871 13.4747 13.532 13.4618 13.577 13.4362Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVoucherRecipient);
export default __webpack_public_path__ + "static/media/voucher-recipient.ee5c2769b0a3de6438bd605c9a9d8783.svg";
export { ForwardRef as ReactComponent };